import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import ButtonsContainer from './ButtonsContainer/ButtonsContainer.vue'
import ListingContainer from './ListingContainer/ListingContainer.vue'
import PaginationContainer from './PaginationContainer/PaginationContainer.vue'
import MarkedFiltersContainer from '@/components/SerpPage/FiltersContainer/MarkedFilters/MarkedFiltersContainer.vue'
import ComponentLoader from '@/components/ComponentLoader.vue'
import TagList from '@/components/SerpPage/TagList.vue'

import {toRefs, inject, computed} from "vue";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";

import {SmartSearchConfigInterface} from '@/core/types'
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {storeToRefs} from "pinia";
import {useMobileViewStore} from "@/store/MobileViewStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'ResultsContainer',
  setup(__props) {


const {hasSelectedFilters} = storeToRefs(useFiltersStore())
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchConfig = inject<SmartSearchConfigInterface>('SmartSearchConfig')!
const useMarkedFilters = SmartSearchConfig.value.serp.markedFilters.enabled
const {useTop, useBottom} = SmartSearchConfig.value.serp.pagination
const {showAsideFilters} = toRefs(SmartSearchConfig.value.serp.filters)
const {showTagList} = toRefs(SmartSearchConfig.value.serp.tagList)


const serpStore = useSerpResultsStore();
const mobileViewStore = useMobileViewStore();

const {loading, noResultsState, products} = storeToRefs(serpStore)
const filtersStore = useFiltersStore();
const {getFiltersLength} = storeToRefs(filtersStore)
const {isMobileView, isTabletView} = storeToRefs(mobileViewStore)
const classList = computed(() => `smartsearch-serp__results qon-test-class q-position-relative ${isMobileView.value ? 'q-w-100' : ''} ${!noResultsState.value && showAsideFilters.value && getFiltersLength.value ? `${isTabletView.value ? 'q-col-12' : 'q-col-md-8 q-col-lg-9' }` : 'q-col-md-12'}  `)
const shouldShowResultsLoader = computed(() => loading.value && products.value.length === 0)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "smartsearch-serp__results",
    class: _normalizeClass(classList.value)
  }, [
    _createVNode(ComponentLoader, { loading: shouldShowResultsLoader.value }, null, 8, ["loading"]),
    (_unref(useTop))
      ? (_openBlock(), _createBlock(PaginationContainer, {
          key: 0,
          position: 'top'
        }))
      : _createCommentVNode("", true),
    _createVNode(ButtonsContainer),
    (_unref(useMarkedFilters) && _unref(hasSelectedFilters) && !_unref(showAsideFilters))
      ? (_openBlock(), _createBlock(MarkedFiltersContainer, { key: 1 }))
      : _createCommentVNode("", true),
    (_unref(showTagList))
      ? (_openBlock(), _createBlock(TagList, { key: 2 }))
      : _createCommentVNode("", true),
    _createVNode(ListingContainer),
    (_unref(useBottom))
      ? (_openBlock(), _createBlock(PaginationContainer, { key: 3 }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})